import { MutationTree } from "vuex";
import { AuthenticationState, CurrentUser, JwtConfigs } from "./types";
export const mutations: MutationTree<AuthenticationState> = {
    authSuccess(state, data) {
        state.token = data.token;
        state.currentUser = data.currentUser;
        state.jwtConfigs = data.jwtConfigs;
        // Cookie used for GetImage action on <img> tag
        document.cookie = encodeURI("authCookie") + "=" + encodeURI(state.token) + ";path=/;";
    },

    updateToken(state, token) {
        state.token = token;
        // Cookie used for GetImage action on <img> tag
        document.cookie = encodeURI("authCookie") + "=" + encodeURI(token) + ";path=/;";
        state.tokenValidTo = new Date(Date.now() + state.jwtConfigs.jwtExpireSeconds * 1000 + state.jwtConfigs.jwtInvalidSeconds * 1000);
    },

    authClear(state) {
        state.jwtConfigs = {} as JwtConfigs;
        state.autoLogout = false;
        state.token = "";
        state.tokenValidTo = null;
        state.currentUser = {} as CurrentUser;
    },

    setAutoLogout(state, data) {
        state.autoLogout = data;
    }
};
